import { CDN_URL } from '@/const';

export default function prepareCdnVideoUrl(url: string): string {
	if (!url) {
		return '';
	}

	if (!url?.startsWith('http')) {
		return `${CDN_URL}${url?.startsWith('/') ? '' : '/'}${url}`;
	}

	return url;
}
